import { CUSTOMER_TEXT_FIELDS, type CustomerDetails } from '@sp/core';
import { useTranslation } from '../i18n';

export function CustomerFields({
  value,
  onChange,
  disabled = false,
}: {
  value: Partial<CustomerDetails>;
  onChange: (value: Partial<CustomerDetails>) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="grid min-w-0 gap-3 sm:grid-cols-2">
      {CUSTOMER_TEXT_FIELDS.map((field) => (
        <label key={field} className={`field-label min-w-0 ${field === 'notes' ? 'sm:col-span-2' : ''}`}>
          {t(field)}
          {field === 'preferredLanguage' ? (
            <select
              className="field"
              value={value[field] ?? ''}
              disabled={disabled}
              onChange={(e) => onChange({ ...value, [field]: e.target.value || null })}
            >
              <option value="">—</option>
              <option value="en">English</option>
              <option value="ta">தமிழ்</option>
            </select>
          ) : field === 'notes' ? (
            <textarea
              className="field min-h-24"
              data-testid="profile-notes"
              value={value.notes ?? ''}
              maxLength={2000}
              disabled={disabled}
              onChange={(e) => onChange({ ...value, notes: e.target.value || null })}
            />
          ) : (
            <input
              className="field"
              data-testid={`profile-${field}`}
              type={field === 'email' ? 'email' : 'text'}
              placeholder={field === 'birthday' ? 'MM-DD / YYYY-MM-DD' : undefined}
              value={value[field] ?? ''}
              maxLength={250}
              disabled={disabled}
              onChange={(e) => onChange({ ...value, [field]: e.target.value || null })}
            />
          )}
        </label>
      ))}
      <label className="flex min-h-11 items-center gap-2">
        <input
          type="checkbox"
          checked={value.isB2b ?? false}
          disabled={disabled}
          onChange={(e) => onChange({ ...value, isB2b: e.target.checked })}
        />
        {t('b2b')}
      </label>
      <label className="flex min-h-11 items-center gap-2">
        <input
          type="checkbox"
          checked={value.isActive ?? true}
          disabled={disabled}
          onChange={(e) => onChange({ ...value, isActive: e.target.checked })}
        />
        {t('active')}
      </label>
    </div>
  );
}
